export const actionTypes = {
    // filter
    'FILTER_REQUEST_BODY': 'FILTER_REQUEST_BODY',
    'FETCH_FILTER': 'FETCH_FILTER',
    'CLEAR_FILTER': 'CLEAR_FILTER',
    'FILTER_GENDER': 'FILTER_GENDER',
    'FILTER_SELECTED': 'FILTER_SELECTED',
    'FETCH_FILTERED_PRODUCTS': 'FETCH_FILTERED_PRODUCTS',

    // auth
    'SET_TOKEN': 'SET_TOKEN',
    'SET_USER': 'SET_USER',
    'SET_USERID': 'SET_USERID',
    'LOGIN_SUCCESS': 'LOGIN_SUCCESS',
    'LOGOUT': 'LOGOUT',
    'ADD_USER_INFO': 'ADD_USER_INTO',
    'GET_SHIPPING_ADDRESS': 'GET_SHIPPING_ADDRESS',

    // shopping cart
    'FETCH_CART_ITEMS': 'FETCH_CART_ITEMS',
    'ADD_MORE_PRODUCTS': "ADD_MORE_PRODUCTS",
    'ADD_ITEMS': "ADD_ITEMS",
    'CHANGE_QUANTITY': "CHANGE_QUANTITY",
    'REMOVE_ITEM': "REMOVE_ITEM",
    'EDIT_CART': "EDIT_CART",
    'ADD_ITEMS_BACKEND': "ADD_ITEMS_BACKEND",
    'CHANGE_QUANTITY_BACKEND': "CHANGE_QUANTITY_BACKEND",
    'REMOVE_ITEM_BACKEND': "REMOVE_ITEM_BACKEND",
    'EDIT_CART_BACKEND': "EDIT_CART_BACKEND",
    'MERGE_CART_ITEMS': "MERGE_CART_ITEMS",
    'FETCH_CART_SUCCESS': "FETCH_CART_SUCCESS",
    'FETCH_CART_ERROR': "FETCH_CART_ERROR",
    'CART_ITEMS_COUNT': "CART_ITEMS_COUNT",
    'CLEAR_CART': 'CLEAR_CART',

    // checkout
    "SET_SHIPPING_COST": "SET_SHIPPING_COST",
    "SET_TOTAL_PRE_TAX": "SET_TOTAL_PRE_TAX",

    // AI
    "SET_CHAT_OPEN": "SET_CHAT_OPEN",
}